var exports = {
  "aw": "x61f99309--9cd097--slider",
  "hP": "x61f99309--9cd097--slides",
  "$z": "x61f99309--9cd097--prev_button",
  "d": "x61f99309--9cd097--next_button",
};

module.exports = exports;
